<template>
  <section class="resume-section p-3 p-lg-5 d-flex align-items-center" id="contact">
    <div class="w-100">
        <h2 class="mb-5">Thank you for Contacting !</h2>
        <p>I got your awesome email, will catch up with you very soon !</p>
          <router-link to="/" class="btn btn-primary">Home</router-link>
    </div>
  </section>
</template>
<script>
export default {
  name: 'success',
};
</script>
<style scoped>
.btn-primary{
    background-color:#515796;
    border-color:#515796;
}
</style>
